import * as React from 'react';
import { DatePicker as $DatePicker } from 'antd';
import { FieldProps } from 'formik';
import moment from 'moment';
import { FormikFieldProps } from 'formik-antd/lib/FieldProps';
import { Field } from 'formik-antd';
import {
  DatePickerProps as $DatePickerProps,
  MonthPickerProps as $MonthPickerProps,
  RangePickerProps as $RangePickerProps,
  WeekPickerProps as $WeekPickerProps,
} from 'antd/lib/date-picker';

import useTouchDevice from 'hooks/useTouchDevice';

const {
  MonthPicker: $MonthPicker,
  RangePicker: $RangePicker,
  WeekPicker: $WeekPicker,
} = $DatePicker;

export type DatePickerProps = $DatePickerProps & FormikFieldProps;

export const DatePicker = ({
  name,
  validate,
  onChange,
  fast,
  ...restProps
}: DatePickerProps) => {
  const [isTouchDevice] = useTouchDevice();

  return (
    <Field name={name} validate={validate} fast={fast}>
      {({
        field: { value },
        form: { setFieldValue, setFieldTouched },
      }: FieldProps) => (
        // eslint-disable-next-line
        <$DatePicker
          inputReadOnly={isTouchDevice}
          value={value ? moment(value) : undefined}
          onChange={(date, dateString) => {
            setFieldValue(name, date ? date.toISOString() : null);

            onChange && onChange(date, dateString);

            setTimeout(() => {
              setFieldTouched(name, true, false);
            }, 0);
          }}
          {...restProps}
        />
      )}
    </Field>
  );
};

export default DatePicker;

DatePicker.MonthPicker = ({
  name,
  validate,
  onChange,
  ...restProps
}: MonthPickerProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isTouchDevice] = useTouchDevice();

  return (
    <Field name={name} validate={validate}>
      {({
        field: { value },
        form: { setFieldValue, setFieldTouched },
      }: FieldProps) => (
        // eslint-disable-next-line
        <$MonthPicker
          inputReadOnly={isTouchDevice}
          value={value ? moment(value) : undefined}
          onChange={(date, dateString) => {
            setFieldValue(name, date ? date.toISOString() : null);
            setFieldTouched(name, true, false);
            onChange && onChange(date, dateString);
          }}
          {...restProps}
        />
      )}
    </Field>
  );
};

DatePicker.RangePicker = ({
  name,
  validate,
  onChange,
  ...restProps
}: RangePickerProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isTouchDevice] = useTouchDevice();

  return (
    <Field name={name} validate={validate}>
      {({
        field: { value },
        form: { setFieldValue, setFieldTouched },
      }: FieldProps) => (
        // eslint-disable-next-line
        <$RangePicker
          name={name}
          value={value}
          inputReadOnly={isTouchDevice}
          onChange={(dates, dateStrings) => {
            setFieldValue(name, dates);
            setFieldTouched(name, true, false);
            onChange && onChange(dates, dateStrings);
          }}
          {...restProps}
        />
      )}
    </Field>
  );
};

DatePicker.WeekPicker = ({
  name,
  validate,
  onChange,
  ...restProps
}: WeekPickerProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isTouchDevice] = useTouchDevice();

  return (
    <Field name={name} validate={validate}>
      {({
        field: { value },
        form: { setFieldValue, setFieldTouched },
      }: FieldProps) => (
        // eslint-disable-next-line
        <$WeekPicker
          name={name}
          value={value}
          inputReadOnly={isTouchDevice}
          onChange={(date, dateString) => {
            setFieldValue(name, date);
            setFieldTouched(name, true, false);
            onChange && onChange(date, dateString);
          }}
          {...restProps}
        />
      )}
    </Field>
  );
};

export type WeekPickerProps = FormikFieldProps & $WeekPickerProps;
export type RangePickerProps = FormikFieldProps & $RangePickerProps;
export type MonthPickerProps = FormikFieldProps & $MonthPickerProps;
